// Lightweight replacement for @rails/ujs
// Handles data-method and data-confirm on links, data-back and data-submit-on-enter anywhere

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[data-method], a[data-confirm]');
  if (!link) return;

  // Handle data-confirm
  if (link.dataset.confirm && !confirm(link.dataset.confirm)) {
    e.preventDefault();
    return;
  }

  // Handle data-method (DELETE, PATCH, PUT)
  if (link.dataset.method && link.dataset.method.toLowerCase() !== 'get') {
    e.preventDefault();

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = link.href;

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrfToken) {
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = 'authenticity_token';
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);
    }

    // Add method override
    const methodInput = document.createElement('input');
    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = link.dataset.method;
    form.appendChild(methodInput);

    document.body.appendChild(form);
    form.submit();
  }
});

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-back]')) history.back();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Enter' && e.target.matches('[data-submit-on-enter]')) e.target.form.submit();
});
